import { render, staticRenderFns } from "./AdminUserSettings.vue?vue&type=template&id=37a489ce&scoped=true"
import script from "./AdminUserSettings.vue?vue&type=script&lang=js"
export * from "./AdminUserSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminUserSettings.vue?vue&type=style&index=0&id=37a489ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a489ce",
  null
  
)

export default component.exports